import { render, staticRenderFns } from "./CheckpointMicrolearningVideoCard.vue?vue&type=template&id=12df4e68&scoped=true"
import script from "./CheckpointMicrolearningVideoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckpointMicrolearningVideoCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CheckpointMicrolearningVideoCard.vue?vue&type=style&index=0&id=12df4e68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12df4e68",
  null
  
)

export default component.exports